// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3rF-6","sendOtp":"AuthorizeToLogin_sendOtp__1i_6E"};